import React from "react";
import { Panel } from "../../components/panels";
import AdvancingProvideListItem from "./AdvancingProvideListItem";

interface Props {
  config: server.dto.DashboardAdvancingProvidePanelConfig
}

const AdvancingProvidePanel = (props: Props) => {
  return <Panel
    panelClassName="s1_dashboard-panel"
    title={props.config.headerLabel}
    subTitle={RESX.Advancing.PleaseProvideInformation}
  >
    <div className="advancing-session-list">
      {props.config.data.map(item =>
        <AdvancingProvideListItem key={item.advancingParticipantId} item={item} />
      )}
    </div>
  </Panel >;
};

export default AdvancingProvidePanel;